import { useFragment, graphql } from 'react-relay';
import { getPriceFromAmountListByCurrency } from 'dibs-buyer-price/exports/getPriceFromAmountListByCurrency';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';
import { isPriceAboveLimit } from './helpers';

import { useShowPricingGuidance_item$key } from './__generated__/useShowPricingGuidance_item.graphql';

const itemFragment = graphql`
    fragment useShowPricingGuidance_item on Item {
        pricingGuidance(
            isTrade: $isTrade
            buyerId: $userId
            userCountryCode: $userCountryCode
            priceBookName: $priceBookName
        ) {
            medianAmount {
                convertedAmountList {
                    amount
                    currency
                }
            }
        }
        displayPrice(
            isTrade: $isTrade
            buyerId: $userId
            userCountryCode: $userCountryCode
            priceBookName: $priceBookName
        ) {
            convertedAmountList {
                # eslint-disable-next-line relay/unused-fields
                amount
                currency
            }
        }
    }
`;

export const useShowPricingGuidance = ({
    item: itemRef,
    currency,
    includeVariantCheck = true,
}: {
    item?: useShowPricingGuidance_item$key | null;
    currency: string;
    includeVariantCheck?: boolean;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const { pricingGuidance, displayPrice = null } = item || {};

    const { pdpPricingGuidanceVariant } = useServerVarsContext();

    if (!pricingGuidance || (includeVariantCheck && pdpPricingGuidanceVariant === 'variant-a')) {
        return false;
    }

    const price = getPriceFromAmountListByCurrency(
        displayPrice?.[0]?.convertedAmountList || null,
        currency
    );

    if (!price) {
        return false;
    }

    const median = getPriceFromAmountListByCurrency(
        pricingGuidance.medianAmount?.convertedAmountList || null,
        currency
    );

    if (isPriceAboveLimit({ price, median, currency })) {
        return false;
    }

    return true;
};
